import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {AutomatService} from '../services/automat.service';
import {AddAutomat} from '../models/addAutomat';
import {Firms} from '../models/firms';
import {NgxSpinnerService} from 'ngx-spinner';
import {StaffService} from '../services/staff.service';
import {AutomatBrandService} from '../services/automat-brand.service';
import {AutomatModelService} from '../services/automat-model.service';
import { GeocodingHelperService } from '../helpers/geocoding.helper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FirmService } from '../services/firm.service';

declare var $: any;

@Component({
    selector: 'app-add-automat',
    templateUrl: './add-automat.component.html',
    styleUrls: ['./add-automat.component.css']
})
export class AddAutomatComponent implements OnInit {

    @ViewChild('SuccessSwal') private SuccessSwal: SwalComponent;
    @ViewChild('ErrorSwal') private ErrorSwal: SwalComponent;

    // google maps zoom level
    zoom = 6;
    // initial center position for the map
    lat = 39.334943;
    lng = 35.177772;
    mapStyles: any;
    // END : Google maps variables

    mapAutomat: any = {};
    automat: AddAutomat = new AddAutomat();
    cashlessConfig = {
        featureLevel: '', countryCode: '', scaleFactor: '', decimalPlaces: '', maxRespTime: '', miscOptions: '',
        automat: ''
    };

    // Service data variables
    public automatGroups: AddAutomat[] = [];
    public allFirms: Firms[] = [];
    public haveGroups: [any];
    public haveNotGroups: [any];
    public models = [];
    public devices = [];
    public vPoses = [];
    public beacons = [];
    public sims = [];
    public modems = [];
    public cities = [];
    public districts = [];
    public neighborhoods = [];
    public staffs = [];
    public brands = [];
    // END : Service data variables
    public firmId: string;
    // Add image variables
    @ViewChild('cropInput') cropInput: ElementRef;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    // END : Add image variables
    public firm: any;

    page = 1;
    pages = 1;
    loading = false;
    selector: string = '.add-automat-list';

    constructor(private automatService: AutomatService,
                private automatBrandService: AutomatBrandService,
                private automatModelService: AutomatModelService,
                private firmService: FirmService,
                private staffService: StaffService,
                public activeModal: NgbActiveModal,
                private geocodingHelperService: GeocodingHelperService,
                private router: Router, private spinner: NgxSpinnerService) {

    }

    ngOnInit() {
        setTimeout(() => this.spinner.show());
        this.firm = localStorage.getItem('firm');
        this.firmId = '';
        this.initializeVariable();
        this.clearAutomat();
        this.getAllBrands();
        this.getAllCities();
        this.getAllFirms();
    }

    getAutomatGroupsByFirm() {
        this.automatService.getAutomatGroupsByFirm(this.firmId).subscribe(response => {
            this.haveGroups = response.haveAutomats;
            this.haveNotGroups = response.haveNotAutomats;


            for (const have of this.haveGroups) {
                this.automatGroups.push(have._id.group[0]);
            }
            for (const havent of this.haveNotGroups) {
                this.automatGroups.push(havent);
            }
        });
    }
    getDevicesForAddAutomat() {
        this.automatService.getDevicesForAddAutomat(this.firmId).subscribe(response => {
            for (const device of response.dataDevices) {
                if (device.status === 0) {
                    this.devices.push(device);
                }
            }

        });
    }
    getVPossesForAddAutomat() {
        this.automatService.getVPossesForAddAutomat(this.firmId).subscribe(response => {
            for (const index of response.dataVPos) {
                if (index.status === 0) {
                    this.vPoses.push(index);
                }
            }

        });
    }
    getBeaconsForAddAutomat() {
        this.automatService.getBeaconsForAddAutomat(this.firmId).subscribe(response => {
            for (const index of response.dataBeacons) {
                if (index.status === 0) {
                    this.beacons.push(index);
                }
            }
        });
    }
    getSimsForAddAutomat() {
        this.automatService.getSimsForAddAutomat(this.firmId).subscribe(response => {
            for (const index of response.dataSimCards) {
                if (index.status === 0) {
                    this.sims.push(index);
                }
            }

        });
    }
    getModemsForAddAutomat() {
        this.automatService.getModemsForAddAutomat(this.firmId).subscribe(response => {
            for (const index of response.dataModems) {
                if (index.status === 0) {
                    this.modems.push(index);
                }
            }
        });
    }
    getStaffByFirm() {
        this.staffService.getStaffByFirm(this.firmId).subscribe(Response => {
            Response.result.forEach(data => {
                if (data.status === 0) {
                    this.staffs.push(data);
                }
            });
        }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.ErrorSwal.title = error.status;
              this.ErrorSwal.text = error.error;
              this.ErrorSwal.show();
              console.log('Error:', error);
            }
        });
    }
    getAllBrands() {
        this.automatBrandService.getAllBrands(this.page).subscribe(response => {
            this.brands = response.docs;
            this.pages = response.pages;
        }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.ErrorSwal.title = error.status;
              this.ErrorSwal.text = error.error;
              this.ErrorSwal.show();
              console.log('Error:', error);
            }
        });
    }
    getAllCities() {
        this.automatService.getAllCities().subscribe(res => {
            this.cities = res;
            this.spinner.hide();
        });
    }
    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            this.spinner.hide();
            if (res.success) {
                this.allFirms = res.firms;
            }
        }, error => {
            this.spinner.hide();
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.ErrorSwal.title = error.status;
                this.ErrorSwal.text = error.error;
                this.ErrorSwal.show();
            }
        });
    }
    close() {
        this.activeModal.close({success: true, message: 'Kapat', data: null});
    }
    markerDragEnd($event: any) {
        this.mapAutomat.lat = $event.coords.lat;
        this.mapAutomat.lng = $event.coords.lng;
        this.automat.location.coordinates = [];
        this.automat.location.coordinates.push(this.mapAutomat.lat);
        this.automat.location.coordinates.push(this.mapAutomat.lng);
    }
    getAutomatModels(brand) {
        if (brand) {            
            const automatBrandId = brand._id;
            this.spinner.show();
            this.automatModelService.getAutomatModelsByBrand(automatBrandId).subscribe(res => {
                this.models = res.data;
                this.spinner.hide();
            });
        }
    }
    onAutomatBrandChange(brand) {
        this.automat.automatModel._id = null;
        this.getAutomatModels(brand);
    }
    onFirmSelectChange(firm) {
        console.log(firm);
        this.firmId = firm._id;
        this.firm = firm.name;
        this.getAutomatGroupsByFirm();
        this.getDevicesForAddAutomat();
        this.getVPossesForAddAutomat();
        this.getBeaconsForAddAutomat();
        this.getSimsForAddAutomat();
        this.getModemsForAddAutomat();
        this.getStaffByFirm();
    }
    getDistricts(cityKey: string, name: string) {
        this.automat.province = name;
        this.automatService.getDistrictsByCity(cityKey).subscribe(res => {
            this.districts = res;
            this.neighborhoods = [];
        });
    }

    getNeighborhoods(districtKey: string, name: string) {
        this.automat.district = name;
        this.automatService.getNeighborhoodsByDistrict(districtKey).subscribe(res => {
            this.neighborhoods = res;
        });
    }


    initializeVariable() {
        this.mapAutomat.lat = this.lat;
        this.mapAutomat.lng = this.lng;
        this.mapAutomat.isOpen = true;
    }

    clearAutomat() {
        this.automat = new AddAutomat();

        // Reset image croppers
        this.cropInput.nativeElement.value = '';
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.cropperReady = false;
    }

    clickInputElement() {
        this.cropInput.nativeElement.click();
    }

    isCoinChange(e) {
        this.automat.isCoin = !!e;
    }

    isCardChange(e) {
        this.automat.isCard = !!e;
    }

    isPreSalesCardChange(e) {
        this.automat.isPreSalesCard = !!e;
    }

    isMobilChange(e) {
        this.automat.isMobil = !!e;
    }

    isStockChange(e) {
        if (!!e) {
            this.automat.isStock = 1;
        } else {
            this.automat.isStock = 0;
        }
    }

    convertToFile(base64Str: string, fileName: string, automatId: string) {

        const binary = atob(base64Str.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], automatId + '.jpg',
            {type: 'image/jpeg', lastModified: Date.now()});
    }

    isFieldsOkay(): boolean {
        let isOkay = true;
        if (this.automat.district === '' || this.automat.district === undefined) {
            isOkay = false;
        }
        if (this.automat.group._id === '-1') {
            isOkay = false;
        }
        if (this.automat.automatModel._id === '-1') {
            isOkay = false;
        }
        if (this.automat.name === '' || this.automat.name === undefined) {
            isOkay = false;
        }
        if (this.automat.neighborhood === '' || this.automat.neighborhood === undefined) {
            isOkay = false;
        }
        // if (this.automat.operator === '' || this.automat.operator === undefined) { isOkay = false; }
        if (this.automat.province === '' || this.automat.province === undefined) {
            isOkay = false;
        }
        if (this.automat.serial === '' || this.automat.serial === undefined) {
            isOkay = false;
        }
        if (this.automat.device._id === '-1') {
            isOkay = false;
        }
        if (this.automat.vPos && this.automat.vPos._id === '-1') {
            this.automat.vPos = null;
        }
        if (this.automat.beacon && this.automat.beacon._id === '-1') {
            this.automat.beacon = null;
        }
        if (this.automat.sim && this.automat.sim._id === '-1') {
            this.automat.sim = null;
        }
        if (this.automat.modem && this.automat.modem._id === '-1') {
            this.automat.modem = null;
        }
        if (this.automat.location.coordinates.length === 0) {
            isOkay = false;
        }
        if (this.cashlessConfig.countryCode === '' || this.cashlessConfig.countryCode === null) {
            isOkay = false;
        }
        if (this.cashlessConfig.decimalPlaces === '' || this.cashlessConfig.decimalPlaces === null) {
            isOkay = false;
        }
        if (this.cashlessConfig.featureLevel === '' || this.cashlessConfig.featureLevel === null) {
            isOkay = false;
        }
        if (this.cashlessConfig.maxRespTime === '' || this.cashlessConfig.maxRespTime === null) {
            isOkay = false;
        }
        if (this.cashlessConfig.miscOptions === '' || this.cashlessConfig.miscOptions === null) {
            isOkay = false;
        }
        if (this.cashlessConfig.scaleFactor === '' || this.cashlessConfig.scaleFactor === null) {
            isOkay = false;
        }
        if (isOkay) {
            return true;
        } else {
            this.ErrorSwal.title = 'Hata';
            this.ErrorSwal.text = 'Lütfen açıklama alanı dışında boş alan bırakmayınız!\nOtomatın konumunu belirlemek için haritayı kullanınız!';
            this.ErrorSwal.show();
            return false;
        }
    }

    handleAutomat() {
        this.spinner.show();
        if (!this.isFieldsOkay()) {
            this.spinner.hide();
            return;
        }
        // this.automat.firm._id = this.firmId;
        this.automatService.addAutomat(this.automat).subscribe(Response => {
            this.cashlessConfig.automat = Response._id;
            this.automatService.addCashlessConfig(this.cashlessConfig).subscribe(res => {
                if (this.croppedImage && this.croppedImage !== '') {
                    const formData = new FormData();
                    const ImageFile = this.convertToFile(this.croppedImage, this.cropInput.nativeElement.files[0].name, Response._id);
                    formData.append('upfile', ImageFile);
                    this.automatService.addAutomatImage(formData, Response._id).subscribe(response => {
                        this.SuccessSwal.text = 'Otomat başarılı bir şekilde oluşturuldu!';
                        this.SuccessSwal.show();
                        this.spinner.hide();
                        this.router.navigate(['firm-automats']);
                    }, error => {
                        this.ErrorSwal.text = 'Eklediğiniz otomatın resmi kaydedilemedi!';
                        this.ErrorSwal.show();
                        this.spinner.hide();
                    });
                } else {
                    this.SuccessSwal.text = 'Otomat resimsiz bir şekilde oluşturuldu!';
                    this.SuccessSwal.show();
                    this.spinner.hide();
                    this.router.navigate(['firm-automats']);
                }
            }, error => {
                this.ErrorSwal.text = 'Cashless bilgileri veritabanına eklenemedi!';
                this.ErrorSwal.show();
                this.spinner.hide();
            });

        }, error => {
            this.ErrorSwal.text = 'Otomat veritabanına eklenemedi!';
            this.ErrorSwal.show();
            this.spinner.hide();
        });
    }

    // Image crop functions
    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        this.cropperReady = true;
    }

    imageLoadFailed() {
        this.ErrorSwal.text = 'Seçtiğiniz resim işlenirken sorun oluştu! Lütfen farklı bir resim deneyiniz';
        this.ErrorSwal.show();
    }

    // END : Image crop functions

    navigateTo(path: string) {
        this.router.navigate([path]);
    }

    validatePrice(event: KeyboardEvent, val) {
        if (event.code !== 'Backspace') {
          const check = new RegExp(/^[0-9]*[.,]?([0-9][0-9]?)?$/igm);
          const checkstr = (val || '') + '' + event.key;
          if (!check.test(checkstr)) {
            event.preventDefault();
          }
        }
    }

    selectAddress(){
        this.geocodingHelperService.getLatLngFromAdress(this.automat.province, this.automat.district, this.automat.neighborhood).subscribe(
          latlng => {
            this.mapAutomat.lat = latlng.results[0].geometry.location.lat;
            this.mapAutomat.lng = latlng.results[0].geometry.location.lng;
            this.automat.location.coordinates = [this.mapAutomat.lat, this.mapAutomat.lng];
          });
    }

    onScrollBrand() {
        if (this.page + 1 > this.pages) { return; }
          $('#page-loader').fadeIn();
          this.page += 1;
          this.automatBrandService.getAllBrands(this.page)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.brands.push(item);
                      this.brands = [...this.brands];
                  }
                  this.pages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.ErrorSwal.title = 'Automat devamı yüklenemedi!';
                  this.ErrorSwal.show();      
              });
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/add-automat/add-automat.component.ts